import { useCallback, useEffect } from 'react';
import getThrottledRAF from '../../helpers/getThrottledRAF';

const TRACK_PERCENTAGES = [0.25, 0.5, 0.75, 0.9];

// Support only (for now) a depth tracker of an element horizontal scroll
const ScrollDepthTracker = ({
  children,
  pageName,
  pageURL,
  scrollRef,
  scrollLeftOffset = 0,
  scrollDepthOffset = 0
}) => {
  const dataLayerPush = useCallback(
    percentage => {
      window.dataLayer.push({
        event: 'scrollDepthPageTrack',
        pageName,
        pageURL,
        percentage
      });
    },
    [pageName, pageURL]
  );

  useEffect(() => {
    const scrollRefElement = scrollRef.current;
    const throttledRAF = getThrottledRAF();
    const trackedPercentages = {};

    const scrollEvent = () =>
      throttledRAF(() => {
        const scrollDepth =
          scrollRefElement.scrollWidth - scrollRefElement.offsetWidth + scrollDepthOffset;
        const scrollOffset = scrollRefElement.scrollLeft + scrollLeftOffset;

        TRACK_PERCENTAGES.forEach(percentage => {
          if (!trackedPercentages[percentage] && scrollOffset >= scrollDepth * percentage) {
            trackedPercentages[percentage] = true;
            dataLayerPush(percentage);
          }
        });
      });

    scrollRefElement.addEventListener('scroll', scrollEvent);

    return () => scrollRefElement.removeEventListener('scroll', scrollEvent);
  }, []);

  return children;
};

export default ScrollDepthTracker;
